import React from 'react';

import { DatasourceModel, DatasourceType, WidgetTableColumnsData } from 'jamespot-user-api';

import { WidgetDatasourceModelView } from '../../components/WidgetDatasourceModelView';
import { StudioEditorFetch } from './StudioEditorFetch';
import { StudioEditorObject } from './StudioEditorObject';
import { DATASOURCE_TYPE } from '../../const';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetDatasourceContext } from '../../JRCWidgetDatasourceTableEditor';

export const StudioEditor = ({
    uri,
    tableColumnsData,
    model,
    type,
}: {
    uri?: string;
    model?: DatasourceModel;
    type?: DatasourceType;
    tableColumnsData: WidgetTableColumnsData;
}) => {
    const { onChange } = useEditorContext<WidgetDatasourceContext>();

    if (type === undefined) {
        return <StudioEditorFetch />;
    }

    return (
        <>
            {uri && type === DATASOURCE_TYPE.STUDIO && (
                <StudioEditorObject
                    uri={uri}
                    onHandleRemove={() =>
                        onChange({
                            tableColumnsData: [],
                            uri: undefined,
                        })
                    }
                />
            )}
            {uri !== undefined && model && type === DATASOURCE_TYPE.STUDIO && (
                <WidgetDatasourceModelView model={model} tableColumnsData={tableColumnsData} onChange={onChange} />
            )}
        </>
    );
};
